import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import ThemedText from '../components/common/ThemedText';
import { useTheme } from '../theme/ThemeContext';
import { useAuth } from '../context/AuthContext';

const DeactivatedScreen: React.FC = () => {
  const { theme } = useTheme();
  const { logout } = useAuth();

  return (
    <View style={[styles.container, { backgroundColor: theme.background }]}>
      <View style={styles.content}>
        <View style={[styles.iconContainer, { backgroundColor: '#F44336' + '20' }]}>
          <Ionicons name="ban" size={80} color="#F44336" />
        </View>

        <ThemedText style={[styles.title, { color: theme.text }]}>
          Account Deactivated
        </ThemedText>

        <ThemedText style={[styles.message, { color: theme.textSecondary }]}>
          Your account has been deactivated by an administrator.
        </ThemedText>

        <ThemedText style={[styles.message, { color: theme.textSecondary }]}>
          You cannot access the platform at this time.
        </ThemedText>

        <ThemedText style={[styles.contactMessage, { color: theme.textSecondary }]}>
          Please contact the admin for assistance if you believe this is an error.
        </ThemedText>

        <TouchableOpacity
          style={[styles.logoutButton, { borderColor: theme.accent, backgroundColor: theme.backgroundSecondary }]}
          onPress={logout}
          activeOpacity={0.7}
        >
          <ThemedText style={[styles.logoutButtonText, { color: theme.accent }]}>
            Logout
          </ThemedText>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  content: {
    alignItems: 'center',
    maxWidth: 400,
  },
  iconContainer: {
    width: 160,
    height: 160,
    borderRadius: 80,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 32,
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    marginBottom: 16,
    textAlign: 'center',
  },
  message: {
    fontSize: 16,
    lineHeight: 24,
    textAlign: 'center',
    marginBottom: 12,
  },
  contactMessage: {
    fontSize: 14,
    lineHeight: 20,
    textAlign: 'center',
    marginTop: 24,
    marginBottom: 32,
    fontStyle: 'italic',
  },
  logoutButton: {
    minWidth: 200,
    marginTop: 16,
    paddingVertical: 14,
    paddingHorizontal: 32,
    borderRadius: 8,
    borderWidth: 1.5,
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoutButtonText: {
    fontSize: 16,
    fontWeight: '600',
  },
});

export default DeactivatedScreen;
